import { ReactNode, useEffect, useState } from 'react';
import styles from './Map.module.scss';
import { DeckGlMap } from './DeckGl/DeckGlMap';
import { useAppDispatch } from 'app/store/store';
import { setMode } from 'app/utils/mapStateSlice';
import { useAlertHook } from 'app/hooks/useAlertHook';
import { useTranslation } from 'react-i18next';

interface Props {
  mode?: string;
  sideComponent?: ReactNode;
  initCenter: number[];
}
export const MapPage = ({ mode, sideComponent, initCenter }: Props) => {
  const localZoom = localStorage.getItem('zoom');
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { addAlert } = useAlertHook();

  useEffect(() => {
    dispatch(setMode(mode || null));
  }, [mode]);

  const [initZoom] = useState<number>((localZoom && JSON.parse(localZoom)) || 4);

  const handleMapLoadError = async (e: Error) => {
    if (e.message === 'invalid latitude') {
      addAlert({
        data: {
          title: 'Info',
          detail: 'Info',
          messages: [{ description: t('InvalidLatitude'), type: 'information' }],
        },
      });
      localStorage.setItem('center', '[0, 0]');
    }
  };

  return (
    <div className={styles.wrapper}>
      {sideComponent && <div className={styles.side_content}>{sideComponent}</div>}
      <DeckGlMap
        center={initCenter}
        zoom={initZoom}
        onError={(e) => handleMapLoadError(e).then(() => window.location.reload())}
      />
    </div>
  );
};
